import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import {
    Button,
    Container,
    ContentWrapper,
    FieldWrapper,
    FormWrapper,
    Heading,
    Input,
    Label,
    Select,
    StepIndicator,
    StepWrapper,
    TopBar,
} from "./styles";
import payment from "../../services/payment";
import PaymentStep from "../PaymentStep";
import { toast } from "react-toastify";
import { TextField } from "@material-ui/core";
import EventApi from "../../services/event";
import TicketSelectionStep from "../TicketSelectionStep";

const Registration = () => {
    const [step, setStep] = useState(1);
    const [personData, setPersonData] = useState({
        name: "",
        email: "",
        phone: "",
        certificate: 0,
        enable: true,
        vip: false,
        status_id: 1,
        solicitation_approved: false,
        is_guest: false,
        company: "",
        role: "",
        gender: "",
        cpf: "",
    });

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [clientSecret, setClientSecret] = useState(null);
    const [confirmEmail, setConfirmEmail] = useState("");
    const [acceptedTerms, setAcceptedTerms] = useState(true);
    const [acceptedCenpComunication, setAcceptedCenpComunication] = useState(true);
    const [acceptedPartnersComunication, setAcceptedPartnersComunication] = useState(true);
    const [ticketData, setTicketData] = useState({});
    const [productList, setProductList] = useState([]);

    const onChange = (event) => {
        const { name, value } = event.target;
        setPersonData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validFormFields = () => {
        let isValid = true;
        const errors = [];
        Object.entries(personData).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            if (key === "email") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um endereço de email");
                } else if (value.length < 3) {
                    isValid = false;
                    errors.push("Insira um endereço de email válido");
                } else if (value !== confirmEmail) {
                    isValid = false;
                    errors.push("Os emails são diferentes");
                }
            }
            if (key === "phone") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira um numero para contato");
                }
            }
            if (key === "company") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira uma instituição");
                }
            }
            if (key === "cpf") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira seu CPF ou Passaporte");
                }
            }
            // if (key === "birth") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira a data de nascimento");
            //     }
            // }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        return {
            ...personData,
            phone: personData.phone ? personData.phone.match(/\d/g).join("") : null,
            cpf: personData.cpf ? personData.cpf.match(/\d/g).join("") : null,
            event_id: `1`,
            accepted_terms: acceptedTerms,
            allow_marketing: acceptedCenpComunication,
        };
    };

    const handleSubscribe = async () => {
        if (!validFormFields()) return;
        setStep(2); // Avança para a seleção de ingressos
    };

    const handleTicketSelection = async (selectedTickets) => {
        setTicketData(selectedTickets);

        try {
            const formatedData = formatData();
            const createPersonResult = await EventApi.createPerson(formatedData);
            if (createPersonResult && createPersonResult.data) {
                toast.success("Inscrição realizada!");
                await startPayment(createPersonResult.data?.id, selectedTickets);
                setStep(3);
            } else if (createPersonResult?.response?.data?.message?.includes("Already used")) {
                if (createPersonResult?.response?.data?.message?.includes("email"))
                    toast.error("O email inserido já foi cadastrado");
                if (createPersonResult?.response?.data?.message?.includes("cpf"))
                    toast.error("O CPF inserido já foi cadastrado");
            } else toast.error("Ocorreu um erro.\nEntre em contato com a organização");
        } catch (error) {
            console.log(error);
            toast.error("Erro ao processar inscrição. Tente novamente.");
        }
    };

    const startPayment = async (personId, tickets) => {
        try {
            const itens = tickets.map((t) => ({ id: t.id, amount: t.unit_amount, quantity: t.quantity }));
            const response = await payment.createPaymentIntent({
                itens: itens,
                currency: "brl",
                personData: { id: personId, purchase: JSON.stringify(itens) },
            });

            setClientSecret(response.data.clientSecret);
        } catch (error) {
            console.log(error);
            toast.error("Erro ao iniciar pagamento.");
        }
    };

    useEffect(() => {
        const getProducts = async () => {
            const products = await payment.getPrices("DEMO");
            if (products && products?.data && products?.data?.data) {
                setProductList(products?.data?.data);
            } else {
                toast.error("Ocorreu um erro ao buscar dados");
            }
        };

        getProducts();
    }, []);

    return (
        <Container>
            <TopBar>
                <StepIndicator isActive={step === 1}>Inscrição</StepIndicator>
                <StepIndicator isActive={step === 2}>Ingressos</StepIndicator>
                <StepIndicator isActive={step === 3}>Pagamento</StepIndicator>
            </TopBar>
            <ContentWrapper>
                {step === 1 && (
                    <FormWrapper>
                        <TextField
                            name="name"
                            label="Digite seu nome completo"
                            required
                            fullWidth
                            value={personData.name}
                            onChange={onChange}
                            inputProps={{
                                maxLength: 255,
                            }}
                        />
                        <InputMask
                            mask="999.999.999-99"
                            value={personData.cpf}
                            onChange={onChange}
                            disabled={false}
                            maskChar=""
                            type="text"
                            name="cpf"
                            required
                        >
                            {() => (
                                <TextField
                                    name="cpf"
                                    label="Digite seu CPF"
                                    required
                                    fullWidth
                                    value={personData.cpf}
                                    onChange={onChange}
                                />
                            )}
                        </InputMask>
                        <TextField
                            name="company"
                            label="Órgão/Instituição"
                            required
                            fullWidth
                            value={personData.company}
                            onChange={onChange}
                        />
                        <TextField
                            name="email"
                            label="Digite seu email"
                            required
                            fullWidth
                            value={personData.email}
                            onChange={onChange}
                        />
                        <TextField
                            name="confirm_email"
                            label="Confirme seu email"
                            required
                            fullWidth
                            value={confirmEmail}
                            onChange={(e) => {
                                e.preventDefault();
                                setConfirmEmail(e.target.value);
                            }}
                            error={confirmEmail !== personData.email}
                            type="email"
                            onPaste={(e) => {
                                e.preventDefault();
                                return false;
                            }}
                        />
                        <InputMask
                            mask="+55 (99) 9 9999-9999"
                            value={personData.phone}
                            onChange={onChange}
                            disabled={false}
                            maskChar=""
                            type="text"
                            name="phone"
                            required
                            color="#fefefe"
                        >
                            {() => (
                                <TextField
                                    name="phone"
                                    label="Digite um telefone para contato"
                                    fullWidth
                                    value={personData.phone}
                                    onChange={onChange}
                                    required
                                />
                            )}
                        </InputMask>

                        <Button type="button" onClick={handleSubscribe}>
                            Cadastrar
                        </Button>
                    </FormWrapper>
                )}

                {step === 2 && (
                    <StepWrapper>
                        <TicketSelectionStep onSubmit={handleTicketSelection} productList={productList} />
                    </StepWrapper>
                )}

                {step === 3 && clientSecret && (
                    <StepWrapper>
                        <PaymentStep
                            clientSecret={clientSecret}
                            clientEmail={personData.email}
                            clientName={personData.name}
                            itens={ticketData}
                            clientCpf={personData.cpf}
                        />
                    </StepWrapper>
                )}
            </ContentWrapper>
        </Container>
    );
};

export default Registration;
